import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

// Import modules
import authStore from './auth';
import meStore from './me';
import stringsStore from './strings';
import navigationStore from './navigation';
import helpStore from './help';
import editorStore from './editor';
import filtersStore from './filters';
import logStore from './log';
import libraryStore from './library';
import statistics from './statistics';
import sparepartsStore from './spare-parts';

// Let Vue work with Vuex
Vue.use(Vuex);

// Enable persistent state
const vuexLocal = new VuexPersist({
  storage: window.localStorage,
});

export default new Vuex.Store({
  // Strict mode in dev only
  strict: process.env.NODE_ENV === 'development',

  plugins: [vuexLocal.plugin],
  modules: {
    authStore,
    meStore,
    stringsStore,
    navigationStore,
    helpStore,
    editorStore,
    filtersStore,
    logStore,
    libraryStore,
    statistics,
    sparepartsStore,
  },
});
